<template>
  <div>
    <div class="flex items-center space-x-4">
      <h2>{{ isEditing ? "Editar" : "Crear" }} Alimento</h2>
    </div>

    <div v-if="!loading" class="card mt-2">
      <form v-if="dietCategories" @submit.prevent="save">
        <div class="flex flex-col w-full">
          <label for="diet_category_id">Categoría</label>
          <custom-select
            id="diet_category_id"
            v-model="form.diet_category_id"
            :options="getDiteCategoryOptions()"
          />
          <validation-errors
            :errors="errorFor('diet_category_id')"
          ></validation-errors>
        </div>

        <div class="flex flex-col w-full mt-6">
          <label for="name">Nombre</label>
          <input id="name" type="text" v-model="form.name" />
          <validation-errors :errors="errorFor('name')"></validation-errors>
        </div>

        <primary-button type="submit" class="mt-6 mx-0" :loading="loadingForm"
          >{{ isEditing ? "Guardar" : "Crear" }}
        </primary-button>
      </form>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import validationErrors from "@/mixins/validationErrors";
import { is422 } from "@/utils/response";
export default {
  name: "Diet Category Form",

  data() {
    return {
      form: {
        name: "",
        diet_category_id: null,
      },
      loading: false,
      loadingForm: false,
      dietCategories: null,
    };
  },

  created() {
    this.$store.commit("setSelectedTab", "dietCategories");

    this.loadDietCategories();
  },

  mixins: [validationErrors],

  methods: {
    async loadDietCategories() {
      this.loading = true;

      try {
        this.dietCategories = await api.resources.getDietCategories();
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    getDiteCategoryOptions() {
      const options = [{ value: null, label: "Seleccionar", disabled: false }];

      this.dietCategories.forEach((petType) => {
        options.push({
          value: petType.id,
          label: petType.name,
        });
      });

      return options;
    },

    save() {
      if (!this.validateForm()) {
        this.$store.dispatch(
          "errorSnack",
          "Favor de llenar todos los campos correctamente."
        );
        return;
      }

      this.createDietCategory();
    },

    validateForm() {
      this.errors = {};

      if (!this.form.name) {
        this.errors["name"] = ["Campo requerido"];
      }

      if (!this.form.diet_category_id) {
        this.errors["diet_category_id"] = ["Campo requerido"];
      }

      return Object.keys(this.errors).length === 0;
    },

    async createDietCategory() {
      this.loadingForm = true;

      try {
        const response = await api.dietCategories.create(this.form);
        this.$store.dispatch("successSnack", response.message);
        this.$router.push({ name: 'dietCategoriesIndex' });
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingForm = false;
    },
  },
};
</script>